import { ClasseVitesse } from './classe-vitesse';
import { Prelevement } from './prelevement';

export class PrelevementVitesse {
    id: number;
    substratId: number;

    Representativite: number;
    Vitesse: ClasseVitesse;

    Prelevements: Prelevement[] = [];

    static mapFromJSON(json): PrelevementVitesse {
        const pv = new PrelevementVitesse();

        pv.Representativite = json.representativite;
        pv.Vitesse = json.vitesse;

        if (json.prelevements) {
            pv.Prelevements = json.prelevements.map(jsonItem => Prelevement.mapFromJSON(jsonItem));
        }

        return pv;
    }
}
